import { render, staticRenderFns } from "./expVideoTxt.vue?vue&type=template&id=f29b463e&scoped=true&"
import script from "./expVideoTxt.vue?vue&type=script&lang=js&"
export * from "./expVideoTxt.vue?vue&type=script&lang=js&"
import style0 from "./expVideoTxt.vue?vue&type=style&index=0&id=f29b463e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f29b463e",
  null
  
)

export default component.exports